import { getDeviceId } from '../../../assets/js/common/nSure';
import client from '../api';

const post = async (path, postBody) => {
  const deviceId = await getDeviceId();
  // eslint-disable-next-line no-undef
  return client().post(`/public/authentication-service/v1${path}`, postBody, {
    headers: {
      'X-Device-ID': deviceId,
      'X-PB-User-Agent': `pb-front/${APP_VERSION}`,
    },
  });
}

export default {
  loginUser(tokens) {
    return post('/users/login', tokens);
  },
  
  logoutUser() {
    return post('/users/logout');
  },
}
